<template>
    <div>
        <div class="header pb-2">
            <img src="images/logos/bitacorapp-logo96x39.png" alt="" />
        </div>
        <div class="body">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.header {
    background-color: #ff761c;
    height: 50px;
}
</style>>

</style>
